<style scoped lang="scss" type="text/scss">
    .award-item-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #FFF;
        border-radius: .1rem;
        overflow: hidden;

        &.large {
            .text-panel {

                .award-name {
                    font-size: 1.1rem;
                }
            }
        }

        .icon-container {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #EEE;

            .c-icon {
                font-size: 4.5rem;
            }
        }

        .text-panel {
            height: 5rem;
            width: 100%;
            box-sizing: border-box;
            padding: .8rem 1rem .8rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            background-color: rgba(0, 0, 0, .85);

            .award-name {
                font-size: 1rem;
                color: #DDD;
            }

            .competition-name {
                font-size: .8rem;
                color: #AAA;
            }
        }
    }
</style>

<template>
    <div class="award-item-container" :class="{'large': false === isNameShort}">
        <div class="icon-container">
            <svg class="c-icon" aria-hidden="true">
                <use :xlink:href="'#' + cIcon"></use>
            </svg>
        </div>
        <div class="text-panel">
            <span class="award-name">{{ awardName }}</span>
            <span class="competition-name">{{ competitionName }}</span>
        </div>
    </div>
</template>

<script>
    import NormalImage from '../../../../components/normal-image/index';

    export default {
        name: '',
        props: {
            cIcon: {
                type: String,
                default: null
            },
            awardName: {
                type: String,
                default: null
            },
            competitionName: {
                type: String,
                default: null
            }
        },
        components: {
            NormalImage
        },
        data () {
            return {};
        },
        computed: {
            isNameShort () {
                return this.awardName && this.awardName.length >= 11;
            }
        }
    };
</script>
